import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action } from 'mobx';
import moment from 'moment';

import * as constants from '../../model/const';

import { Focuspoint } from '../component/Focuspoint';
import { SiteHeader } from '../component/SiteHeader';
import { SiteFooter } from '../component/SiteFooter';

import { BWStepBar } from '../component/BWStepBar';
import { BWReceipt } from '../component/BWReceipt';

import { Dropdown } from '../component/Dropdown';

import { ItemDescriptor } from '../component/ItemDescriptor';

import translateBase from '../../translate';
import { fmtPrice, fmtPercent, fmtDatetime, fmtDate, fmtTime } from '../../model/formatters';

let translate = translateBase.bindPage('bw05Review')

function servicesWahlbar(aggServices) {
  return aggServices.joinedListing
    .filter(service => service.inTransaction.id)
    .filter(o => o.available.typeId === constants.SERVICE_TYPE.WAHLBAR)
}

function servicesObligatorisch(aggServices) {
  return aggServices.joinedListing
    .filter(service => service.inTransaction.id)
    .filter(o => o.available.typeId === constants.SERVICE_TYPE.OBLIGATORISCH)
}

function servicesBedingt(aggServices) {
  return aggServices.joinedListing
    .filter(service => service.inTransaction.id)
    .filter(o => o.available.typeId === constants.SERVICE_TYPE.BEDINGT)
}

function servicesBeiReservation(aggServices) {
  return aggServices.joinedListing
    .filter(service => service.inTransaction.id)
    .filter(o => o.available.typeId === constants.SERVICE_TYPE.BEIRESERVATION)
}

function accessoriesWahlbar(aggAccessories) {
  return aggAccessories.joinedListing
    .filter(o => o.inTransaction)
    .filter(o => !o.isObligatory);
}

function accessoriesObligatorisch(aggAccessories) {
  return aggAccessories.joinedListing
    .filter(o => o.inTransaction)
    .filter(o => o.isObligatory);
}

class ServiceItem extends React.Component {
  render() {
    const {
      editing,
      decription,
      name,
      description,
      currency,
      unitPrice,
      percentagePrice,
      itemCount,
      onIncrease,
      onDecrease,
      canInc,
      canDec,
      choosenPrice,
      canBeSelected,
      serviceTypeId,
      onEditItemStart,
      onSaveItem,
      onDeleteItem,
    } = this.props;
    return (
      <div className={"list-entry" +
        (editing ? " edit-state" : "") +
        (((choosenPrice || (itemCount * unitPrice)) < 0) ? " discount" : "")}>
        <div className="input">
          {name}
          {((choosenPrice || (itemCount * unitPrice)) < 0) &&
            <span>{translate("discount", "Rabatt")}</span>
          }
        </div>
        <div className="value">{!percentagePrice ? `${currency} ${fmtPrice(unitPrice)}` : `${fmtPercent(percentagePrice)}%`}</div>
        <div className="amount">
          <input value={itemCount} readOnly />
          <a className={"minus" + (canDec ? "" : " unselectable")} onClick={onDecrease}><i className="fa fa-minus"></i></a>
          <a className={"plus" + (canInc ? "" : " unselectable")} onClick={onIncrease}><i className="fa fa-plus"></i></a>
        </div>
        {canBeSelected && <div className={"verify-btns" + (!canBeSelected ? " noneditable-item" : "")}>
          <a className="edit" onClick={onEditItemStart}><i className="fa fa-pencil" aria-hidden="true"></i></a>
          <a className="save" onClick={onSaveItem}><i className="fa fa-floppy-o" aria-hidden="true"></i></a>
          <a className="delete" onClick={onDeleteItem}><i className="fa fa-trash" aria-hidden="true"></i></a>
        </div>}
        <div className="price">{currency} {fmtPrice(choosenPrice || itemCount * unitPrice || 0)}</div>
      </div>
    )
  }
}

class AccessoryItem extends React.Component {
  render() {
    const {
      editing,
      description,
      name,
      currency,
      flatPrice,
      prolongationPrice,
      unitPrice,
      itemCount,
      onIncrease,
      onDecrease,
      canInc,
      canDec,
      price,
      canBeSelected,
      onEditItemStart,
      onSaveItem,
      onDeleteItem,
    } = this.props;
    return (
      <div className={"list-entry" +
        (editing ? " edit-state" : "") +
        (((flatPrice || 0) + (prolongationPrice || 0) + (unitPrice || 0) < 0) ? " discount numeral" : "")}>
        <div className="input">
          <span className="number">{itemCount}</span>
          {name}
        </div>
        <div className="value">{currency} {fmtPrice((flatPrice || 0) + (prolongationPrice || 0) + (unitPrice || 0))}</div>
        <div className="amount">
          <input value={itemCount} readOnly />
          <a className={"minus" + (canDec ? "" : " unselectable")} onClick={onDecrease}><i className="fa fa-minus"></i></a>
          <a className={"plus" + (canInc ? "" : " unselectable")} onClick={onIncrease}><i className="fa fa-plus"></i></a>
        </div>
        {canBeSelected && <div className={"verify-btns" + (!canBeSelected ? " noneditable-item" : "")}>
          <a className="edit" onClick={onEditItemStart}><i className="fa fa-pencil" aria-hidden="true"></i></a>
          <a className="save" onClick={onSaveItem}><i className="fa fa-floppy-o" aria-hidden="true"></i></a>
          <a className="delete" onClick={onDeleteItem}><i className="fa fa-trash" aria-hidden="true"></i></a>
        </div>}
        <div className="price">{currency} {fmtPrice(price)}</div>
      </div>
    )
  }
}

@inject(stores => ({
  navigation: stores.app.navigation,
  wServices: stores.app.wServices,
  wAccessories: stores.app.wAccessories,
  vReview: stores.app.vReview,
  vPayment: stores.app.vPayment,
  servicesForm: stores.app.servicesForm,
  accessoriesForm: stores.app.accessoriesForm,
  rentalTransaction: stores.app.rentalTransaction,
  rentalObject: stores.app.rentalObject,
  bestOffers: stores.app.bestOffers,
  aggServices: stores.app.aggServices,
  aggAccessories: stores.app.aggAccessories,
  businessUnit: stores.app.businessUnit,
  organization: stores.app.organization,
}))
@observer
export class BWReview extends React.Component {

  render() {
    const { navigation, servicesForm, accessoriesForm, rentalTransaction, rentalObject,
      bestOffers, aggServices, aggAccessories, vReview, vPayment, businessUnit, organization } = this.props;

    const currency = businessUnit.currencyName; //"CHF";
    const srvWahlbar = servicesWahlbar(aggServices);
    const srvObligatorisch = servicesObligatorisch(aggServices);
    const srvBedingt = servicesBedingt(aggServices);
    const srvBeiReservation = servicesBeiReservation(aggServices);

    const getDiscountTitle = () => {
      return rentalTransaction.totalDiscount > 0 ?
        translate("totalSurcharge", "Total Surcharge") :
        translate("totalDiscount", "Total Rabatt")
    }

    const getDiscountDetails = () => {
      let discounts = [];
      let hasFeeDiscount = rentalTransaction.discountRate != 0;
      let hasSvcDiscount = rentalTransaction.normServiceDiscount != 0;
      let hasConsDiscount = rentalTransaction.consumableDiscountPrice != 0;
      if (hasFeeDiscount) {
        discounts.push(rentalTransaction.rentalFeeDiscountName);
      }
      if (hasSvcDiscount) {
        discounts.push(rentalTransaction.serviceDiscountName);
      }
      if (hasConsDiscount) {
        discounts.push(rentalTransaction.consumablesDiscountName);
      }
      let uniqueDiscounts = [...new Set(discounts)];
      return uniqueDiscounts.join(' / ');
    }

    const isFwdDisabled = () => {
      if (!vReview.agbAccepted) {
        return true;
      }
      if (rentalObject.notesRequest && !vReview.bookingNote) {
        return true;
      }
      if (rentalObject.notesRequest2 && !vReview.bookingNote2) {
        return true;
      }
      return false;
    }

    const getFwdTitle = () => {
      return isFwdDisabled() ? translate("nextTitle", "Alle Pflichtfelder müssen ausgefüllt und die AGBs akzeptieren werden.") : null;
    }

    const getFwdClass = () => {
      return isFwdDisabled() ? "forward disabled" : "forward";
    }

    const onFwdClick = () => {
      var proceed = true;
      if (vReview.agbAccepted) {
        if (rentalObject.notesRequest && !vReview.bookingNote) {
          proceed = false;
        }
        if (rentalObject.notesRequest2 && !vReview.bookingNote2) {
          proceed = false;
        }
      } else {
        proceed = false;
      }
      if (proceed) {
        if (rentalTransaction.totalDiscountedPrice === 0) {
          console.log('value 0');
          console.log(vReview.rentalTransaction.id, vReview.orgId);
          vPayment.finishBooking(vReview.orgId, vReview.rentalTransaction.id);
        } else {
          navigation.goBWPayment();
        }
      }
    }

    return (
      <div>
        <SiteHeader />

        <BWStepBar activeStep={5} />

        <section className="wizard-container booking-view">
          <div className="wrapper">

            <div className="row wizard-content">
              <div className="column-12">
                <h3 className="mali-blue">{translate("review", "Überprüfen")}</h3>

                <div className="verify-container">
                  <div className="row">
                    <div className="column-8">
                      <div className="product-container">
                        <figure className="product-image">
                          <div className="spacer"></div>
                          <Focuspoint
                            src={rentalObject.thumbnailUrl}
                            imageW={756}
                            imageH={415}
                            focusX={0.0}
                            focusY={0.0}
                            reCalcOnWindowResize={true}
                          />
                        </figure>
                        <div className="product-details">
                          <div className="product-name biggest">
                            {rentalTransaction.name}
                          </div>
                          <div className="product-total">
                            <div className="label">{translate("mietbetrag", "Mietbetrag")}</div>
                            <div className="amount">{currency}{" "}{fmtPrice(rentalTransaction.totalDiscountedPrice)}{" "}
                              <span className="amount-note">{translate("vatIncluded", "inkl. Mwst.")}</span>
                            </div>
                            <div className="price-detail-trigger">
                              <a><i className="fa fa-info" aria-hidden="true"></i></a>
                            </div>
                          </div>
                          <div className="product-location">
                            <i className="fa fa-map-marker" aria-hidden="true"></i> {rentalObject.businessUnitName}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="column-4">
                      <div className="bookingdates-container">
                        <div className="booking-center">
                          <div className="from">
                            <div className="label">{translate("bookedFrom", "Buchung von")}</div>
                            <div className="value">{rentalTransaction.rentingStartDate &&
                              fmtDatetime(rentalTransaction.rentingStartDate)}</div>
                          </div>
                          <div className="till">
                            <div className="label">{translate("bookedTo", "bis")}</div>
                            <div className="value">{rentalTransaction.rentingEndDate &&
                              fmtDatetime(rentalTransaction.rentingEndDate)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="column-12">

                      <div className="verify-entry">
                        <div className="title">{translate("offer", "Angebot")}</div>
                        {rentalTransaction.mainObjectOffers.map(offer => {
                          return (
                            <div className={"list-entry"}>
                              <div className="input">
                                <span className="number">{offer.quantity}</span>
                                {offer.name}
                                {offer.prolongationOfferQuantity > 0 &&
                                  <div className="prolongation">
                                    <span className="number">{offer.prolongationOfferQuantity}</span>
                                    {offer.prolongationName}
                                  </div>}
                              </div>
                              <div className="value">{currency} {fmtPrice(offer.price)}</div>
                              <div className="amount">
                                <input value={0} readOnly />
                                <a className={"minus unselectable"} ><i className="fa fa-minus"></i></a>
                                <a className={"plus unselectable"} ><i className="fa fa-plus"></i></a>
                              </div>
                              <div className="price">{currency} {fmtPrice(offer.price)}</div>
                            </div>
                          )
                        })}

                        {(srvWahlbar.length > 0 || srvBedingt.length > 0 || srvBeiReservation.length > 0 || srvObligatorisch.length > 0) &&
                          <div className="title">{translate("services", "Dienstleistungen")}</div>
                        }
                        {srvWahlbar.map(service => {
                          return <ServiceItem
                            editing={vReview.editingId === service.available.id}
                            decription={service.available.description}
                            name={service.available.name}
                            currency={currency}
                            unitPrice={service.available.price}
                            percentagePrice={service.available.percentagePrice}
                            itemCount={servicesForm.values.get(service.available.id)}
                            onIncrease={() => servicesForm.incAmount(service.available.id)}
                            onDecrease={() => servicesForm.decAmount(service.available.id)}
                            canInc={servicesForm.canInc(service.available.id)}
                            canDec={servicesForm.canDec(service.available.id)}
                            choosenPrice={service.inTransaction.price}
                            canBeSelected={true || service.available.canBeSelected}
                            serviceTypeId={service.available.typeId}
                            onEditItemStart={() => vReview.editItemStart(service.available.id)}
                            onSaveItem={() => vReview.saveServiceItem(service.available.id)}
                            onDeleteItem={() => vReview.deleteServiceItem(service.available.id)} />
                        })}
                        {srvObligatorisch.map(service => {
                          return <ServiceItem
                            editing={vReview.editingId === service.available.id}
                            decription={service.available.description}
                            name={service.available.name}
                            currency={currency}
                            unitPrice={service.available.price}
                            itemCount={servicesForm.values.get(service.available.id)}
                            onIncrease={() => servicesForm.incAmount(service.available.id)}
                            onDecrease={() => servicesForm.decAmount(service.available.id)}
                            choosenPrice={service.inTransaction.price}
                            canBeSelected={false && service.available.canBeSelected}
                            serviceTypeId={service.available.typeId}
                            onEditItemStart={() => vReview.editItemStart(service.available.id)}
                            onSaveItem={() => vReview.saveServiceItem(service.available.id)}
                            onDeleteItem={() => vReview.deleteServiceItem(service.available.id)} />
                        })}
                        {srvBedingt.map(service => {
                          return <ServiceItem
                            editing={vReview.editingId === service.available.id}
                            decription={service.available.description}
                            name={service.available.name}
                            currency={currency}
                            unitPrice={service.available.price}
                            itemCount={servicesForm.values.get(service.available.id)}
                            onIncrease={() => servicesForm.incAmount(service.available.id)}
                            onDecrease={() => servicesForm.decAmount(service.available.id)}
                            choosenPrice={service.inTransaction.price}
                            canBeSelected={false && service.available.canBeSelected}
                            serviceTypeId={service.available.typeId}
                            onEditItemStart={() => vReview.editItemStart(service.available.id)}
                            onSaveItem={() => vReview.saveServiceItem(service.available.id)}
                            onDeleteItem={() => vReview.deleteServiceItem(service.available.id)} />
                        })}

                        {srvBeiReservation.map(service => {
                          return <ServiceItem
                            editing={vReview.editingId === service.available.id}
                            decription={service.available.description}
                            name={service.available.name}
                            currency={currency}
                            unitPrice={service.available.price}
                            itemCount={servicesForm.values.get(service.available.id)}
                            onIncrease={() => servicesForm.incAmount(service.available.id)}
                            onDecrease={() => servicesForm.decAmount(service.available.id)}
                            choosenPrice={service.inTransaction.price}
                            canBeSelected={false && service.available.canBeSelected}
                            serviceTypeId={service.available.typeId}
                            onEditItemStart={() => vReview.editItemStart(service.available.id)}
                            onSaveItem={() => vReview.saveServiceItem(service.available.id)}
                            onDeleteItem={() => vReview.deleteServiceItem(service.available.id)} />
                        })}

                        {(accessoriesWahlbar(aggAccessories).length > 0 || accessoriesObligatorisch(aggAccessories).length > 0) &&
                          <div className="title">{translate("accessories", "Zubehör")}</div>
                        }
                        {accessoriesWahlbar(aggAccessories).map(accessory => {
                          return <AccessoryItem
                            editing={vReview.editingId === accessory.pk}
                            description={accessory.description}
                            name={accessory.name}
                            currency={currency}
                            flatPrice={accessory.flatPrice}
                            prolongationPrice={accessory.prolongationPrice}
                            unitPrice={accessory.price}
                            itemCount={accessoriesForm.values.get(accessory.pk)}
                            onIncrease={() => accessoriesForm.incAmount(accessory.pk)}
                            onDecrease={() => accessoriesForm.decAmount(accessory.pk)}
                            canInc={accessoriesForm.canInc(accessory.pk)}
                            canDec={accessoriesForm.canDec(accessory.pk)}
                            price={accessory.sumTotalPrice}
                            canBeSelected={true}
                            onEditItemStart={() => vReview.editItemStart(accessory.pk)}
                            onSaveItem={() => vReview.saveAccessoryItem(accessory.pk)}
                            onDeleteItem={() => vReview.deleteAccessoryItem(accessory.pk)} />
                        })}

                        {accessoriesObligatorisch(aggAccessories).map(accessory => {
                          return <AccessoryItem
                            editing={vReview.editingId === accessory.pk}
                            description={accessory.description}
                            name={accessory.name}
                            currency={currency}
                            flatPrice={accessory.flatPrice}
                            prolongationPrice={accessory.prolongationPrice}
                            unitPrice={accessory.price}
                            itemCount={accessoriesForm.values.get(accessory.pk)}
                            onIncrease={() => accessoriesForm.incAmount(accessory.pk)}
                            onDecrease={() => accessoriesForm.decAmount(accessory.pk)}
                            canInc={accessoriesForm.canInc(accessory.pk)}
                            canDec={accessoriesForm.canDec(accessory.pk)}
                            price={accessory.sumTotalPrice}
                            canBeSelected={false}
                            onEditItemStart={() => vReview.editItemStart(accessory.pk)}
                            onSaveItem={() => vReview.saveAccessoryItem(accessory.pk)}
                            onDeleteItem={() => vReview.deleteAccessoryItem(accessory.pk)} />
                        })}

                        {rentalTransaction.deposit > 0 &&
                          <div className="list-entry">
                            <div className="input">
                              {translate("deposit", "Kaution")}
                            </div>
                            <div className="value">{currency} {fmtPrice(rentalTransaction.deposit)}</div>
                            <div className="amount">
                              <input readOnly />
                            </div>
                            <div className="price">{currency} {fmtPrice(rentalTransaction.deposit)}</div>
                          </div>
                        }

                        {
                          rentalTransaction.totalDiscount != 0 &&
                          <div>
                            <div className="title">{getDiscountTitle()}</div>
                            <div className="list-entry discount">
                              <div className="input">
                                {getDiscountDetails()}
                                {rentalTransaction.totalDiscount < 0 && <span>{translate("discount", "Rabatt")}</span>}
                              </div>
                              <div className="price">{currency} {fmtPrice(rentalTransaction.totalDiscount)}</div>
                            </div>
                          </div>
                        }

                        <div className="voucher-container">
                          <div className="title">{translate("voucher", "Voucher")}</div>
                          <div className="list-entry discount">
                            {rentalTransaction.voucherCode && <div className="voucher-entry">
                              <div className="input">
                                {rentalTransaction.voucherCode} <span>{translate("discount", "Rabatt")}</span>
                              </div>
                              <div className="price">{currency} {fmtPrice(rentalTransaction.voucherPrice)}</div>
                            </div>}
                            {!rentalTransaction.voucherCode && <div className="addVoucher">
                              <input type="text" value={vReview.voucherCode} onChange={event => vReview.setVoucherCode(event.target.value)} />
                              <button className="forward" type="button" onClick={vReview.checkVoucherCode}>{translate("addVoucher", "Gutschein hinzufügen")}</button>
                            </div>}
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row notes-container">
              <div className={rentalObject.notesRequest2 ? "column-6" : "column-8"}>
                <div className="title">{rentalObject.notesRequest ? rentalObject.notesRequest + ' *' : 'Notizen'}</div>
                <div className="notes-text">
                  <textarea id="booking-notes" onChange={event => vReview.setBookingNote(event.target.value)} value={vReview.bookingNote} cols={50} maxLength={2000}></textarea>
                </div>
              </div>
              {rentalObject.notesRequest2 &&
                <div className="column-6">
                  <div className="title">{rentalObject.notesRequest2} *</div>
                  <div className="notes-text">
                    <textarea id="booking-notes2" onChange={event => vReview.setBookingNote2(event.target.value)} value={vReview.bookingNote2} cols={50} maxLength={2000}></textarea>
                  </div>
                </div>
              }
            </div>

            <div className="row legal-container">
              {businessUnit.reservationAllowed && <div className="column-6 booking-type"> {/*<!-- show only if temporary reservation is possible --> */}
                <div className="title">{translate("bookAs", "Buchen als")}</div>
                <form>
                  <input type="radio" name="booking-type"
                    onClick={event => vReview.setWillBook(false)}
                    checked={!vReview.willBook} /> {translate("temporaryReservationUntil", "Temporäre Reservation, gültig bis")} {fmtDatetime(businessUnit.reservationExpiration)}<br />
                  <input type="radio" name="booking-type"
                    onClick={event => vReview.setWillBook(true)}
                    checked={vReview.willBook} /> {translate("bookFirmly", "Verbindlich buchen")}
                </form>
              </div>}
              <div className="column-6 agb">
                <input type="checkbox"
                  onClick={event => vReview.setAgbAccepted(event.target.checked)}
                  checked={vReview.agbAccepted} />{translate("acceptAGB", "Ich akzeptiere die ${lessorName}", { lessorName: organization.name })}&nbsp;
                <a target="_blank" href={`/api/public/BusinessUnit/${businessUnit.id}/getCurrentGTC`}>{translate("agb", "AGB")}</a>
              </div>
            </div>

            <div className="row main-wizardbtns-container">
              <div className="column-6">
                <a className="back" onClick={navigation.goBWPersonalData}><i className="fa fa-arrow-left" aria-hidden="true"></i> {translate("back", "Zurück")}</a>
              </div>
              <div className="column-6">
                <a id="btn-fwd-bwreview" title={getFwdTitle()}
                  className={getFwdClass()}
                  onClick={onFwdClick}>{translate("next", "Weiter")} <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
              </div>
            </div>

          </div>
        </section>

        <SiteFooter />
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/visual/view/BWReview.js